// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../pr6433-npm11211-20261015/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../pr6433-npm11211-20261015/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.btn-header button {
  background-color: transparent;
  width: 30px;
  height: 30px;
  border: 0;
}

.btn-header button:hover {
  background-color: var(--darkgrey);
}

.btn-header button i {
  color: var(--white);
  font-size: 10px;
}

@media only screen and (max-width: 979px) and (min-width: 0px) {
  .btn-header button {
    width: 40px;
    height: 40px;
  }
  .btn-header button i.fas {
    color: #ffffff;
    font-size: 16px;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/core/user/logout/logout.component.scss"],"names":[],"mappings":"AAAA;EACE,6BAAA;EACA,WAAA;EACA,YAAA;EACA,SAAA;AACF;;AAEA;EACE,iCAAA;AACF;;AAEA;EACE,mBAAA;EACA,eAAA;AACF;;AAEA;EACE;IACE,WAAA;IACA,YAAA;EACF;EAEA;IACE,cAAA;IACA,eAAA;EAAF;AACF","sourcesContent":[".btn-header button {\n  background-color: transparent;\n  width: 30px;\n  height: 30px;\n  border: 0;\n}\n\n.btn-header button:hover {\n  background-color: var(--darkgrey);\n}\n\n.btn-header button i {\n  color: var(--white);\n  font-size: 10px;\n}\n\n@media only screen and (max-width: 979px) and (min-width: 0px) {\n  .btn-header button {\n    width: 40px;\n    height: 40px;\n  }\n\n  .btn-header button i.fas {\n    color: #ffffff;\n    font-size: 16px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
